import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKKontrollAvAlarmResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Radio, Paper, Stack, Title, Box } from "@mantine/core";
const KontrollAvAlarm: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKKontrollAvAlarmResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Kontroll av alarmer
        </Title>
        <div style={{ width: "50%" }}>
          <div>
            <McTextAreaNew
              label="Beskrivelse av fremgangsmåte:"
              value={data.inndata.beskrivelseAvHvordanAlarmFremprovoseres}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.kontrollAvAlarm.inndata.beskrivelseAvHvordanAlarmFremprovoseres",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <Stack gap={0}>
              <Radio
                checked={data.inndata.godkjent === true}
                onChange={() => onUpdateEditData("testResultater.kontrollAvAlarm.inndata.godkjent", true)}
                label="Godkjent"
              />
              <Radio
                checked={data.inndata.godkjent === false}
                onChange={() => onUpdateEditData("testResultater.kontrollAvAlarm.inndata.godkjent", false)}
                label="Ikke godkjent"
              />
            </Stack>
          </div>
        </div>
        <Box mt="lg" style={{ width: "50%" }}>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.kontrollAvAlarm.inndata.kommentar", e.target.value)}
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default KontrollAvAlarm;
